import { OrderDetailsResponseDto, RefundAttemptDto } from '@tiendanube/common';
import { Stack } from 'commons/components';
import { AlertSessionStorage } from '../../../../../../../App/components';
import useTranslationOrders from '../../../../../useTranslationOrders';

interface Attributes {
  orderDetails: OrderDetailsResponseDto;
}

function RefundStatusBanner({ orderDetails }: Attributes): JSX.Element | null {
  const t = useTranslationOrders();
  const refundAttempts = [...(orderDetails.payment?.refundAttempts || [])];

  if (refundAttempts.length === 0) return null;

  const statusMap = new Map<string, 'primary' | 'success' | 'danger'>([
    ['success', 'success'],
    ['failed', 'danger'],
  ]);

  const appearance = (
    attempt: RefundAttemptDto,
  ): 'primary' | 'success' | 'danger' =>
    statusMap.get(attempt.status.code) ?? 'primary';

  const title = (attempt: RefundAttemptDto) => {
    const key = attempt.is_partial ? 'partial_title' : 'total_title';
    return t(`refund.bannerMessages.${attempt.status.code}.${key}`);
  };

  return (
    <Stack column>
      {refundAttempts.map((refundAttempt) => (
        <AlertSessionStorage
          key={refundAttempt.id}
          title={title(refundAttempt)}
          appearance={appearance(refundAttempt)}
          keyName={`refund-attempt-banner-${refundAttempt.id}`}
        >
          {t(`refund.bannerMessages.${refundAttempt.status.code}.description`)}
        </AlertSessionStorage>
      ))}
    </Stack>
  );
}

export default RefundStatusBanner;
